<div
  [hidden]="!scopeElementsService.deliverableStates.selected[deliverable.id] || !components?.length"
  class="flex flex-col scope-row-content">
  <scope-components-row-header
    *ngIf="!config?.isTimeline"
    [level]="level"
    [config]="config">
  </scope-components-row-header>
</div>

<div
  id="deliverable-{{ deliverable.id }}"
  cdkDropList
  [cdkDropListData]="deliverable.components"
  [cdkDropListConnectedTo]="config?.deliverableDrops"
  [cdkDropListDisabled]="!config?.isEditable"
  (cdkDropListDropped)="dropComponent($event, deliverable)"
  class="flex flex-col row-content"
  style="min-height: 24px"
  [hidden]="!scopeElementsService.deliverableStates.selected[deliverable.id]">
  <scope-components-row
    *ngFor="let component of components | orderBy: 'order'; trackBy: trackById"
    cdkDrag
    [cdkDragData]="component"
    (cdkDragStarted)="onDragComponent($event)"
    (cdkDragEnded)="scopeElementsService.componentDragging = false; scopeElementsService.dragTargetId = null"
    [level]="level"
    [config]="config"
    [component]="component"
    [changeItem]="(config?.changeItemsMap$ | async)?.[component.changeAuditData?.identity || component.id]"
    [deliverable]="deliverable"
    [componentMenuOptions]="componentMenuOptions"
    [feeMenuOptions]="feeMenuOptions"
    (onUpdateComponent)="onUpdateComponent.emit($event)"
    (onOverrideQuantity)="onOverrideQuantity.emit($event)"
    (onOverrideRateCardRoleHours)="onOverrideRateCardRoleHours.emit($event)"
    (onUpdateComponentFee)="onUpdateComponentFee.emit($event)"
    (onUpdateComponentTpc)="onUpdateComponentTpc.emit($event)"
    (onReorderComponentTpcs)="onReorderComponentTpcs.emit($event)"
    (onUpdateRole)="onUpdateRole.emit($event)">
  </scope-components-row>
</div>
